var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBliggit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8359 41.9417C35.8616 39.4754 42.4961 31.1925 42.4961 21.3486C42.4961 9.55877 32.9808 0 21.2445 0C9.51532 0 0 9.55877 0 21.3486C0 31.1925 6.63447 39.4754 15.6602 41.9417L19.3712 46.468C20.3433 47.6513 22.1457 47.6513 23.1178 46.468L26.8359 41.9417ZM21.2447 9.02425C28.0211 9.02425 33.5132 14.5414 33.5132 21.3487C33.5132 28.1489 28.0211 33.6661 21.2447 33.6732C14.4683 33.6732 8.97627 28.156 8.97627 21.3487C8.97627 14.5414 14.4683 9.02425 21.2447 9.02425Z",
    fill: "#1C363C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8443 18.1838C29.8443 21.2062 27.4034 23.6582 24.3948 23.6582C21.3862 23.6582 18.9453 21.2062 18.9453 18.1838C18.9453 15.1615 21.3862 12.7095 24.3948 12.7095C27.4034 12.7095 29.8443 15.1615 29.8443 18.1838Z",
    fill: "#1C363C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBliggit);
export default __webpack_public_path__ + "static/media/bliggit.bd2bff5f3426bd99a1a5c96db7b864ae.svg";
export { ForwardRef as ReactComponent };